import styled from "styled-components";

export const PillAnchor = styled.a`
&&{  
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  width: 71px;
  height: 23px;
  margin-left:15px;
  background-color: ${props => props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
    font-size: ${props => props.theme.fontSize.secondary};
    font-weight: ${props => props.theme.fontWeight.w500};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: normal;
    padding-left: 0.25rem;
  }

  @media only screen and (max-width: 991.92px) {
    align-self: flex-start;
    margin-left: 0;
    margin-top: 0.2rem;
  }
}
`;